import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';
import DetailsSectionContacts from 'app/main/modules/components/DetailsSectionContacts';

import PeopleEvents from './PeopleEvents';

import PeopleDetailsSectionInfo from './details/sections/PeopleDetailsSectionInfo';
import PeopleDetailsSectionSource from './details/sections/PeopleDetailsSectionSource';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<PeopleDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="peop_descriptionhtml"
				value={props.model.peop_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			{props.isAdd && (
				<>
					<InlineTitle text="DETAILS_CONTACTS_MAILS_SECTION" />
					<DetailsSectionContacts
						module="mails"
						listField="peop_mails"
						list={props.model.peop_mails}
						sendChange={props.sendChange}
					/>
					<InlineTitle text="DETAILS_CONTACTS_PHONES_SECTION" />
					<DetailsSectionContacts
						module="phones"
						listField="peop_phones"
						list={props.model.peop_phones}
						sendChange={props.sendChange}
					/>
				</>
			)}
			<InlineTitle text="DETAILS_SOURCE_SECTION" />
			<PeopleDetailsSectionSource {...props} />
		</>
	),
	events: PeopleEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
